// extracted by mini-css-extract-plugin
export default {"appFooter":"AppFooter_appFooter__J1O1m","text":"AppFooter_text__ssAc5"};